<template>
  <b-dropdown variant="link" no-caret toggle-class="p-0" right>
    <template #button-content>
      <feather-icon icon="MoreVerticalIcon" size="17" class="ml-50 text-body" />
    </template>

    <b-dropdown-item
      @click.prevent="$emit('action-edit')"
      v-if="!isUpdating && !isPublished && !isCurrentUserPublisher"
    >
      <feather-icon icon="EditIcon" />
      <span class="align-middle ml-50">{{$t('MANAGE_NEWS_ITEM.Edit')}}</span>
    </b-dropdown-item>

    <b-dropdown-item @click.prevent="$emit('action-copy')">
      <feather-icon icon="CopyIcon" />
      <span class="align-middle ml-50">{{$t('MANAGE_NEWS_ITEM.Duplicate')}}</span>
    </b-dropdown-item>

    <b-dropdown-item
      @click.prevent="$emit('action-copy')"
      v-if="!isUpdating && !isPublished"
    >
      <feather-icon icon="TrashIcon" />
      <span class="align-middle ml-50">{{$t('MANAGE_NEWS_ITEM.Delete')}}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import AppConstants from "@/appConstants";

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  props: {
    status: {
      type: Number,
    },
  },
  computed: {
    isCurrentUserPublisher() {
      return this.$store.state.auth.currentUser.profile == AppConstants.USER_PROFILE.PUBLISHER;
    },
    isUpdating() {
      return this.status == AppConstants.EVENT_STATUS.EDITING;
    },
    isPublished() {
      return this.status == AppConstants.EVENT_STATUS.PUBLISHED;
    },
  },
  setup() {
    return {};
  },
};
</script>
<style>
</style>